import React from "react";
import { StyledDialog } from "./styles.js";
import { DialogTitle, DialogActions, LinearProgress } from "@mui/material";
import { Button } from "@mui/material";
import { StyledButton } from "../Button/styles.js";
import { StyledTextField } from "../TextField/styles.js";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
export * from "./styles.js";

const ConfirmationDialog = ({ open, handleClose, submit, title, loading }) => {
  return (
    <StyledDialog open={open} onClose={handleClose}>
      {loading && <LinearProgress />}
      <DialogTitle sx={{ fontSize: " 16px" }} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogActions>
        <StyledButton theme="purple" onClick={handleClose}>
          Cancel
        </StyledButton>
        <StyledButton theme="green" onClick={submit} autoFocus>
          Proceed
        </StyledButton>
      </DialogActions>
    </StyledDialog>
  );
};

export const TerminationConfirmationDialog = ({
  open,
  handleClose,
  submit,
  title,
}) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        reasonForTermination: yup
          .string()
          .required("Reason for Termination is required"),
      })
    ),
  });
  return (
    <StyledDialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontSize: " 16px" }} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <form onSubmit={handleSubmit(submit)}>
        <Grid container>
          <Grid item xs={12}>
            <StyledTextField
              {...register("reasonForTermination")}
              style={{ width: "400px" }}
              multiline={true}
              rows={3}
              error={Boolean(errors.reasonForTermination)}
              helperText={errors.reasonForTermination?.message}
              label={"Reason for Termination"}
            />
          </Grid>
        </Grid>
        <DialogActions>
          <StyledButton theme="purple" onClick={handleClose}>
            Cancel
          </StyledButton>
          <StyledButton theme="green" type="submit" autoFocus>
            Proceed
          </StyledButton>
        </DialogActions>
      </form>
    </StyledDialog>
  );
};

export default ConfirmationDialog;
